import { AudioManager } from "../AudioManager";
import { ISystemContext } from "../Context/SystemContext";
import { ITimeout } from "../Context/Timeout";
import { MoneyFormatter } from "../MoneyFormatter";
import { MultigameParams2 } from "../MultigameParams2";
import { FontResource } from "../ResourceManager/FontResource";
import { ImageResource } from "../ResourceManager/ImageResource";
import { PixiSpriteResource } from "../ResourceManager/PixiSpriteResource";
import { Resourceful, Resourceful2 } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { ScreenProtocolScope } from "../ScreenProtocol";
import { SlotGameInitData } from "../SlotGameInitData";
import { Translator } from "../Translator";
import { Size, CreateElement, Scale, Log, LogGroup } from ".././MyHelpers";
import { IBigSymbolFreegames2Factory, BigSymbolFreegames2Factory } from "./Bonus/BigSymbolFreegames/BigSymbolFreegames2";
import { BigSymbolFreegames2Params } from "./Bonus/BigSymbolFreegames/BigSymbolFreegames2Params";
//import { BigSymbolFreegamesConfig } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesConfig";
import { IBigSymbolSpinAndHoldBonusFactory2, BigSymbolSpinAndHoldBonusFactory2 } from "./Bonus/BigSymbolSpinAndHold/BigSymbolHoldAndSpin2Factory";
import { BonuRecoverStatus } from "./Bonus/SlotBonus";
import { SlotBonus2 } from "./Bonus/SlotBonus2";
import { ISpinAndHoldBonusFactory2, SpinAndHoldBonusFactory2 } from "./Bonus/SpinAndHold/SpinAndHold2Factory";
import { SpinAndHold2Params } from "./Bonus/SpinAndHold/SpinAndHold2Params";
import { DiamondSpinFactory2 } from "./DiamondSpin/DiamondSpin2";
import { FreegameBonusFactory2, FreegameBonus2Params } from "./FreegameBonus/FreegameBonus2";
//import { FreegameConfiguration } from "./FreegameBonus/FreegameConfiguration";
import { PayTable } from "./Paytable/Paytable";
import { PickBonusFactory2, PickBonus2Params } from "./PickBonus/PickBonus2";
import { IPickBonusConfiguration } from "./PickBonus/PickBonusParams";
import { SlideFactoryText } from "./Slider/FactorySliderText";
import { IGenericSlider } from "./Slider/GenericSlider";
import { ISlideFactoryGeneric } from "./Slider/ISlideFactory";
import { SlotSpinResult, IBonusStartConfig, IRunResult, SlotGame } from "./SlotGame";
import { SlotGame2 } from "./SlotGame2";
import { SlotGameMessages } from "./SlotGameScreenMessages";
import { SlotGameState } from "./SlotGameState";
import { SlotSymbol } from "./SlotSymbol";
import { SlotSymbolSprite } from "./SlotSymbolSprite";
import { CanvasSprite } from "./Sprite/CanvasSprite";
import { StateMachine, StateChange } from "./StateMachine";
import { JackpotDisplayType, InfoScreenSlider, Settings, FillingPotFeature } from "../Settings";
import { SetStyles } from ".././MyHelpers";
import { Bonus } from "./Bonus/Bonus";
import { IInterval } from "../Context/Interval";
import { IRandomInterval } from "../Context/RandomInterval";
import { PayTable8Squares } from "../slot/Paytable/PayTable8Squares";
import { IPaytableData, ISimplePaytableData, PayTableFactory } from "../slot/Paytable/PayTableFactory";
import { IPanelFactory } from "../slot/panel/IPanelFactory";
import { IPayTableFactory, IPaytableParams } from "../slot/Paytable/IPayTableFactory";
import { IPaytable } from "../slot/Paytable/IPayTable";
import { FactoryDoubleSlide } from "./Slider/Slide2/FactoryDoubleSlide";
import { IExtendedSpinAndHold2Factory, ExtendedSpinAndHold2Factory } from "./Bonus/ExtendedSpinAndHold/ExtendendSpinAndHold2Factory";
import { BonusLoadingItem } from "./Bonus/LoadingItem";
import { ITitleGenericFactory, TitleFactory } from "./TitleSlide/titleSlideFactory";
import { titleGame } from "./TitleSlide/titleGame";
import { ITitleGeneric } from "./TitleSlide/ITitleGeneric";
import { titleParamsFeature } from "./TitleSlide/titleParamsFeature";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import {BigSymbolFreegamesCommonConfiguration, ExtendedSpinAndHoldCommonConfiguration, FreegamesCommonConfiguration, ISimpleBonusAction, SimpleSlotGameState, SpinAndHoldCommonConfiguration } from "../api";

export class SlotGameType1_2 extends SlotGame2
{
	protected systemContext: ISystemContext = null;
	protected view: HTMLElement = null;
	protected video:HTMLElement=null;
	protected basegameView: HTMLElement = null;
	//protected bonusesView: HTMLElement = null;
	protected freegameView: HTMLElement = null;

	protected expandingWildBulkTrigger: HTMLElement = null;
	protected expandingWildReelTrigger: HTMLElement = null;
	protected wildViewTrigger: HTMLElement = null;

	protected bonusTrigger: HTMLElement = null;

	protected expandingWildBulkView: HTMLElement= null;
	protected expandingWildReelView: HTMLElement= null;
	protected wildView: HTMLElement= null;


	protected bonusView:HTMLElement = null;

	protected viewSize: Size = null;

	protected commonpath: string = null;
	//public basepath: string = null;

	protected stateMachine: StateMachine<SlotGameState> = null;
	//protected resid: string = "";
	//protected scopeSelector: string = null;

	protected lastSpinResult: SimpleSlotGameState = null;
	protected bonusStartConfig: IBonusStartConfig = null;


	//protected bonuses: SlotBonus2[] = [];
	//protected freegamebonus: FreegameBonus2 = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//protected titleElement: HTMLElement = null;
	protected titleSpriteDelayTimer: IRandomInterval;
	protected titleView: HTMLElement = null;
	protected titleSprite: CanvasSprite = null;

	//protected pickBonus:PickBonus2 = null;

	protected bonusList: Map<Bonus, SlotBonus2> = new Map<Bonus, SlotBonus2>();
	protected currentBonus: SlotBonus2 = null;

	// SYMBOLS
	protected symbols: SlotSymbol[] = [];
	protected symbolSpriteAnims: SlotSymbolSprite[] = [];
	protected symbolSize: Size = null; // in pixels
	//protected paytable: PayTable = null;

	protected freegameBonusFactory: FreegameBonusFactory2 = new FreegameBonusFactory2();
			
	//USE FOR 3Screen
	//protected freegameBonusFactory: FreegameBonusFactory2 = new FreegameBonusFactory2();	
	protected spinAndHoldFactory: ISpinAndHoldBonusFactory2 = new SpinAndHoldBonusFactory2();	
	protected bigSymbolSpinAndHoldFactory: IBigSymbolSpinAndHoldBonusFactory2 = new BigSymbolSpinAndHoldBonusFactory2();	

	protected pickBonusFactory: PickBonusFactory2 = new PickBonusFactory2();
	protected diamondFactory: DiamondSpinFactory2 = new DiamondSpinFactory2();
	protected bigSymbolFreegamesFactory: IBigSymbolFreegames2Factory = new BigSymbolFreegames2Factory();
	protected extendedSpinAndHoldFactory: IExtendedSpinAndHold2Factory = new ExtendedSpinAndHold2Factory();	
	
	
	//protected diamondFactory: DiamondSpinFactory2 = new DiamondSpinFactory2();
	//protected slideFactory:SlideFactory;
	//protected slideFactory:SlideFactory2Side;
	protected multigameParams: MultigameParams2 = null;
	

	protected moneyFormatter: MoneyFormatter = new MoneyFormatter(0.01);


	//protected secondScreenHelp: SecondScreenHelp = null;
	protected secondScreenHelp: IGenericSlider = null;
	protected seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

	public translator: Translator=null;

	protected titleanim:HTMLElement;
	//title interval zoom
	//protected zoomTitleTimer: IRandomInterval = null;

	protected bonusDelayedBeginTimer: ITimeout;

	//title Slide Factory 
	protected titleSlideView : ITitleGeneric = null;
	protected titleSlideFatory : ITitleGenericFactory = new TitleFactory();

	

	protected bonusLoadSequence: BonusLoadingItem[]= [
		{Bonus: Bonus.FreeGameBonus,        Prepare: (s, r) => this.FreeGamePrepare(s, r),             Loaded: (s, r) => this.FreegamesLoaded(s, r)},
		{Bonus: Bonus.PickBonus,            Prepare: (s, r) => this.PickBonusPrepare(s, r),            Loaded: (s, r) => this.PickBonusLoaded(s, r)},
		{Bonus: Bonus.SpinAndHold,          Prepare: (s, r) => this.SpinAndHoldPrepare(s, r),          Loaded: (s, r) => this.SpinAndHoldLoaded(s, r)},
		{Bonus: Bonus.BigSymbolFreegames,   Prepare: (s, r) => this.BigSymbolFreegamesPrepare(s, r),   Loaded: (s, r) => this.BigSymbolFreegamesLoaded(s, r)},
		{Bonus: Bonus.BigSymbolSpinAndHold, Prepare: (s, r) => this.BigSymbolSpinAndHoldPrepare(s, r), Loaded: (s, r) => this.BigSymbolSpinAndHoldLoaded(s, r)},
		{Bonus: Bonus.ExtendedSpinAndHold,  Prepare: (s, r) => this.ExtendedSpinAndHoldPrepare(s, r),  Loaded: (s, r) => this.ExtendedSpinAndHoldLoaded(s, r)},
	];


	//ADD AUDIO 
	protected audio: AudioManager ;

	protected paytable: IPaytable = null;

	public constructor(multigameParams: MultigameParams2, initData: SlotGameInitData) 
	{
		super(initData, multigameParams);

		this.systemContext = multigameParams.systemContext.CreateSubContext(["SlotGameType1", this.name]);
		this.audio=multigameParams.audio;

		let bonusDelayTimer : number = 1000;
		if(Settings.fillingPotFeature == FillingPotFeature.Enable) bonusDelayTimer = 2700;
		this.bonusDelayedBeginTimer = this.systemContext.TimingContext().CreateTimeout("bonusDelayedBeginTimer", bonusDelayTimer, () => this.OnBonusDelayedBegin());
		
		//this.slideFactory = new SlideFactory();
		//this.slideFactory = new SlideFactoryText ();
	
		this.resid = multigameParams.resid.Add(this.name)
		//new ResourceIdentifier(["SlotGame", this.name, "2"]);
		this.screenProtocolScope = new ScreenProtocolScope(["SlotGame" ,this.name]);

		this.stateMachine = new StateMachine<SlotGameState>(SlotGameState.Idle, this.logGroup, (state: SlotGameState) => SlotGameState[state]);

		this.commonpath = Settings.ResourcesFolder + "multigame/slot/common/";
		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.name + "/";

		this.viewSize = multigameParams.viewSize;
		this.multigameParams = multigameParams;
		
		this.translator = multigameParams.translator;

		this.view = CreateElement("div", {
			classes: [this.resid.ID()],
			style: {
				position: "absolute", 
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				backgroundSize: "cover",
				//zIndex: ZIndex.ElementsMenu.toString(),
			}
		});


		this.stateMachine.SetCallback(SlotGameState.WaitGameStart, StateChange.Begin, () => this.OnWaitGameStartBegin());
		this.stateMachine.SetCallback(SlotGameState.Spin, StateChange.Begin, () => this.OnSpinBegin());

		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(SlotGameState.Bonus, StateChange.End, () => this.OnBonusEnd());

		this.stateMachine.SetCallback(SlotGameState.Win, StateChange.Begin, () => this.OnWinBegin());
		this.stateMachine.SetCallback(SlotGameState.Win, StateChange.End, () => this.OnWinEnd());

		//this.screenProtocol.AddReceiveMessageHandler(SlotGameMessages.RecoverGame.msgname, (message) => this.Recover((<SlotGameMessages.RecoverGame>message).lastGame), this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.StateChange.msgname, 
			(message) => this.stateMachine.ChangeState((<SlotGameMessages.StateChange<SlotGameState>>message).newState), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.SpinResult.msgname, 
			(message) => this.OnSpinResult((<SlotGameMessages.SpinResult>message).spin), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.BonusRunResult.msgname, 
			(message) => this.OnBonusRunResult((<SlotGameMessages.BonusRunResult>message).run), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.BonusFinished.msgname, 
			(message) => this.OnBonusFinished((<SlotGameMessages.BonusFinished>message)), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.WiningSymbol.msgname, 
			(message) => this.WiningSymbol((<SlotGameMessages.WiningSymbol>message).symbol), 
			this.screenProtocolScope
		);

		this.screenProtocol.AddReceiveMessageHandler(
			SlotGameMessages.BetChange.msgname,
			(message) => this.UpdatePaytable((<SlotGameMessages.BetChange>message)),
			this.screenProtocolScope
		)

		// this.screenProtocol.AddReceiveMessageHandler(SlotGameMessages.DenomChange.msgname, (message) => {
		// 	let dc: SlotGameMessages.DenomChange = message as SlotGameMessages.DenomChange;
		// 	this.moneyFormatter.SetDenom(dc.denom);
		// }, this.screenProtocolScope);

		this.symbols = initData.Symbols;
	}

	

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		if (loadingStage != LoadingStage.Games) {
			return;
		}

		await this.BasegamePrepare(resourceManager);		
		await this.BonusesPrepare(loadingStage, resourceManager);
		await this.SymbolsPrepare(resourceManager);
		
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {
			await this.PaytablePrepare(resourceManager);
		} 
		else if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
			await this.TitlePrepare(resourceManager);
		}
	

		
		//await this.FeaturesDescriptionPrepare(resourceManager);
		//await this.BonuDescriptionPrepare(resourceManager);
		await this.PrepareFont(resourceManager);
		await this.AddSecondScreenHelp(resourceManager);


	}

	
	public async AddSecondScreenHelp(resourceManager: IWriteOnlyResourceManager) {
		//CREATE THIS METHOR FOR ADD SLIDER AN OVERWRITE WHEN YOU DONT NEED
		if (Settings.JackpotSlider == InfoScreenSlider.EnableScreen3) {
			//add some option for disable slider 
			this.secondScreenHelp = this.seconScreenHelpFactory.Create({
				gameName: this.name,
				systemContext: this.systemContext,
				initData: this.initData,
				resid: this.resid,
				translator: this.translator,
				logGroup: this.logGroup,
				symbolSpriteAnims: this.symbolSpriteAnims,
				viewSize: this.viewSize,
				backendSettings: this.multigameParams.backendSettings,
				availableSymbols: this.symbols
			});

			if (this.secondScreenHelp != null)
			{
				await this.secondScreenHelp.PrepareResources(resourceManager);
			}
		}
	}

	public PrepareFont(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.Games) {
			return;
		}

		this.basegameView = CreateElement("div", {
			classes: ["basegame"],
			parentToAppend: this.view,
			style: {
				position: "absolute", 
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				backgroundSize: "cover"
			}
		});

		this.titleView = CreateElement("div", {
			classes: ["title"],
            id: "title",
            parentToAppend: this.basegameView,
			style: {
				display: "flex",
				justifyContent: "center",
			}
		});
		
		await this.BasegameLoaded(resourceManager);
		await this.TitleLoaded(resourceManager);
		await this.BonusesLoaded(loadingStage, resourceManager);
		await this.SymbolsLoaded(resourceManager);
		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {
			await this.PaytableLoaded(resourceManager);
		}

		if(this.secondScreenHelp !=null)
		{
			await this.secondScreenHelp.ResourcesLoaded(resourceManager);
			this.basegameView.appendChild(this.secondScreenHelp.View());
		}
	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		let params : titleParamsFeature = {		
			systemContext : this.systemContext,
			LogGroup : this.logGroup,			
			resid : this.resid,
			basePath : this.basepath,
			gameName: this.name,
		}



		this.titleSlideView = this.titleSlideFatory.CreateTitleFactory(params);
		params = null;
		this.titleSlideView?.PrepareResources(resourceManager);
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager)
	{	
		if (this.titleSlideView != null)
		{
			this.titleSlideView.ResourcesLoaded(resourceManager);
			this.titleView.appendChild(this.titleSlideView.View());
		}
	}

	protected bonusStartConfigForRecover: IBonusStartConfig[] =[];



	/*************************************************************************
		BASEGAME
	**************************************************************************/
	protected BasegamePrepare(resourceManager: IWriteOnlyResourceManager): void {
		//resourceManager.Add(new ImageResource(this.basepath + "resources/background.2.png", this.resid.ScopedResourceName(["basegame", "background"])));
	}

	protected BasegameLoaded(resourceManager: IReadOnlyResourceManager) {
		//this.basegameView = this.view.querySelector(".basegame");

        // use this background for basegame and all bonuses
        
        // SetStyles(this.view, {
        //     backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["basegame", "background"])).CssBackground(),
        //     backgroundSize: "cover",
        // });

		// this.bonusesView = this.view.querySelector(".bonuses");
		// this.bonusesView.style.visibility = "hidden"; // hidden by default


		//this.bonusesView.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid + ".")
		//this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid + ".basegame.background").CssBackground();
	}

	protected  readonly symbolsByJackpot = {
		[JackpotDisplayType.RapidDiamondPot] : [ "SRA"],
		[JackpotDisplayType.PlayCityLink]: ["SRA"],
		[JackpotDisplayType.RapidDiamondPotStep]: ["SRA"],
   }

	protected SymbolsPrepare(resourceManager: IWriteOnlyResourceManager): void {
		//resourceManager.Add(new SpriteResource(this.basepath + "resources/lightweight-symbols/symbols_181x181", this.resid.Add("SymbolsIdle"), true, this.logGroup.Add("SymbolsIdle"), true));

		// symbols
		for (let s of this.symbols) {

			let symbolName: string = s.ID;
			let symbolPath = this.basepath + "resources/symbols2/symbol_"+ symbolName;

			if(this.symbolsByJackpot[Settings.JackpotDisplayType]?.includes(symbolName)){
				symbolPath = this.basepath + "resources/SymbolsJackpots/"+ Settings.JackpotDisplayType + "/symbol_" + symbolName;
				symbolName = null
			}
		
			resourceManager.AddGlobal(new PixiSpriteResource(symbolPath , this.resid.Add("Symbol").Add(s.ID).Shared(), true, this.logGroup.Add("Symbol").Add(s.ID), true));
			//resourceManager.AddGlobal(new PixiSpriteResource(this.basepath + "resources/symbols2/symbol_" + n , this.resid.Add("Symbol").Add(s.ID).Shared(), true, this.logGroup.Add("Symbol").Add(s.ID), true));
			symbolPath = null;
			s = null;
		}
	}

	protected SymbolsLoaded(resourceManager: IReadOnlyResourceManager): void {

		this.symbolSize = new Size(150, 150);

		//let allSymbolsSprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("SymbolsIdle")).sprite;

		//let totalSymbolsSpritesSize: number = 0;

		for (let s of this.symbols) {
			let symbolSprite: SlotSymbolSprite;

			try
			{
				symbolSprite = new SlotSymbolSprite(
					this.symbolSize,
					resourceManager.Get<PixiSpriteResource>(this.resid.Add("Symbol").Add(s.ID).Shared()).sprite,
					s.Index,
				);
				s =null ; 

				// let spriteSize: number = symbolSprite.Sprite().shared.decodedFrames.map(f => f.width * f.height * 4).reduce((prev, current) => prev + current);
				// // Log.Debug(this.logGroup, "Symbol " + s.ID + " sprite size: " + formatBytes(spriteSize));
				// totalSymbolsSpritesSize += spriteSize;
			}
			catch (e) {
				Log.Error(this.logGroup, "Unable to load SPRITE for symbol index " + s.Index);
			}

			this.symbolSpriteAnims.push(symbolSprite);
			symbolSprite = null;
		}
	}

	protected PaytablePrepare(resourceManager: IWriteOnlyResourceManager): void {
		const panelFactory: IPayTableFactory = new PayTableFactory();
		let paytableParams : IPaytableParams ={
			paytable: this.initData.Paytable,
			symbolSpriteAnims : this.symbolSpriteAnims,
			viewSize: this.viewSize,
			symbols: this.symbols,
			nameGame: this.name,
			resid: this.resid,
			systemContext: this.systemContext,
			initData: this.initData,
			translator: this.translator,
			symbolsCollection: null,
		} 		
		
		this.paytable =  panelFactory.CreatePayTable(paytableParams);
		paytableParams = null;
		this.paytable.PrepareResources(resourceManager);
		this.paytable.View().style.justifyContent = "center";
		this.paytable.View().style.alignItems = "center";
		//this.paytable.View().style.top = "0px";
		//this.paytable.View().style.position = "absolute";
		//SetStyles(this.paytable.View(), { transform: "scale(0.9)", transformOrigin : "center", margin: "auto"});
	}

	protected PaytableLoaded(resourceManager: IReadOnlyResourceManager): void {
		//this.paytable = new PayTable(this.initData.paytable, this.symbolSpriteAnims, this.viewSize);

		//let paytableView = this.paytable.View();
		//paytableView.style.top = "700px";

		//this.view.querySelector(".paytable-container").appendChild(this.paytable.View());
		
		// SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
		// {
		// 	backgroundImage : resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["paytable", "background"])).CssBackground(),
		// 	borderRadius:"0px",
			
		// });
		
		// this.paytable.Update(true);

		//Create pay table 
		//this is only work for 2 screens and PaytableJackpotDisplaType
		// const panelFactory: IPayTableFactory = new PayTableFactory();
		// let paytableParams : IPaytableParams ={
		// 	paytable : this.initData.PayTable,
		// 	symbolSpriteAnims : this.symbolSpriteAnims,
		// 	viewSize : this.viewSize,
		// 	symbols : this.symbols,
		// 	nameGame : this.name,
		// } 
		
		
		// this.paytable =  panelFactory.CreatePayTable(paytableParams);
		// this.paytable.BuildPaytable();
		this.paytable.ResourcesLoaded(resourceManager)
		this.basegameView.appendChild(this.paytable.View());		
		this.paytable.Update(true);	
		
		//Add img background container paytable
		// hmmm
		// SetStyles(this.basegameView.querySelectorAll(".paytable-symbol-container"),
		// {
		// 	backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.name, "paytable", "background"]).Scope()).CssBackground(),
		// 	borderRadius:Scale.XYpx(0),
		// 	backgroundSize: "contain",
		// 	backgroundRepeat: "no-repeat",
		// 	backgroundPosition: "center",
		// });

		
	}

	protected UpdatePaytable(message: SlotGameMessages.BetChange)
	{
		//UPDATE VALUE IN PAYTABLE SECONSCREENHELP
		this.secondScreenHelp?.SetBet(message);

		//UPDATE PAYTABLE FOR 2ScREENS 
		//ONLY ITS ACTIVE WHEN JACKPOTDIPLAYTYPE ARE IN PAYTABLEJACKPOT
		this.paytable?.SetBet(message);
		
	}
	

	/*************************************************************************
		BONUSES - FREEGAME SCREEN
	**************************************************************************/
	public async BonusesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{

		if (this.initData.BonusConfiguration)
		{
			for (let [bonusName, bonus] of Object.entries(this.initData.BonusConfiguration))
			{
				let prepareItem = this.bonusLoadSequence.find(s => s.Bonus == bonusName);
				if (!prepareItem)
				{
					throw `Unknown bonus ${bonusName}`;
				}

				if (prepareItem.Prepare)
				{
					await prepareItem?.Prepare(loadingStage, resourceManager);
				}
			}
		}
	}

	public async BonusesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (this.initData.BonusConfiguration)
		{
			for (let [bonusName, bonus] of Object.entries(this.initData.BonusConfiguration))
			{
				let prepareItem = this.bonusLoadSequence.find(s => Bonus[s.Bonus] == bonusName);
				if (prepareItem.Loaded)
				{
					await prepareItem.Loaded(loadingStage, resourceManager);
					bonusName = null;
					prepareItem = null;
				}
			}
		}
	}

	// protected DiamondSpinPrepare(resourceManager:ResourceManager)
	// {
	// 	let dsParams: DiamondSpinParams2 = 
	// 	{
	// 		systemContext: this.systemContext,
	// 		gameName: this.name,
	// 		resid: this.resid,
	// 		logGroup: this.logGroup,
	// 		screenProtocol: this.screenProtocol, 
	// 		screenProtocolScope: this.screenProtocolScope,
	// 		gameResourcesBasePath: this.basepath + "resources/DiamondSpin/", 
	// 		commonResourcesBasePath: this.commonpath + "resources/DiamondSpin/",
	// 		viewSize: this.viewSize,
	// 		bonusConfiguration: this.initData.bonusConfiguration.DiamondSpin as DiamondSpinConfiguration,
	// 		moneyFormatter: this.moneyFormatter,
	// 		translator: this.translator	
	// 	};

	// 	let diamondSpin: SlotBonus2 = this.diamondFactory.CreateDiamondSpin2(this.resid, dsParams);
	// 	diamondSpin.PrepareResources(resourceManager);
		
	// 	this.bonusList.set("DiamondSpin", diamondSpin);
	// }

	// protected DiamondSpinLoaded(resourceManager:ResourceManager)
	// {
	// 	let diamondSpin = this.bonusList.get(Bonus.DiamondSpin);
	// 	diamondSpin.ResourcesLoaded(resourceManager);
		
	// 	let diamondSpinView = diamondSpin.View();
	// 	diamondSpinView.style.width = this.multigameParams.viewSize.width + "px";
	// 	diamondSpinView.style.height = this.multigameParams.viewSize.height + "px";

	// 	this.view.appendChild(diamondSpinView);

	// 	diamondSpin.Hide();
	// }

	protected async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;

		let pickBonusparams: PickBonus2Params =
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			viewSize: this.viewSize,
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus as IPickBonusConfiguration,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio,
		};

		let bonus: SlotBonus2 = this.pickBonusFactory.CreatePickBonus2(this.resid, pickBonusparams);
		await bonus.PrepareResources(loadingStage, resourceManager);
		pickBonusparams = null
		
		this.bonusList.set(Bonus.PickBonus, bonus);
		bonus = null;
	}
	protected async PickBonusLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;
		
		let bonus: SlotBonus2 = this.bonusList.get(Bonus.PickBonus);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);

		
		let bonusView = bonus.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";

		this.view.appendChild(bonusView);

		bonus.Hide();
		bonus= null;
	}

	protected async FreeGamePrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;
		
		let freegameConfig: FreegamesCommonConfiguration = this.initData.BonusConfiguration.FreeGameBonus;
		let freegameParams: FreegameBonus2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};
		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.freegameBonusFactory.CreateFreegameBonus2(this.resid, freegameConfig, freegameParams);
		//this.freegamebonus = new FreegameBonus2(this.resid, freegameConfig, freegameParams);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "Freegame bonus created");

		this.bonusList.set(Bonus.FreeGameBonus,bonus);
		freegameConfig = null;
		bonus = null;
		freegameParams = null;
	}

	protected async FreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonus: SlotBonus2 = this.bonusList.get(Bonus.FreeGameBonus);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);
		//this.bonusView.appendChild(freegameBonus.)
		
		let bonusView = bonus.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";
			
		this.view.appendChild(bonusView);

		// hide all bonuses by default
		bonus.Hide();
		bonus = null;
		bonusView = null;
	}


	protected async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.spinAndHoldFactory.CreateSpinAndHold2(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "SpinAndHold bonus created");

		this.bonusList.set(Bonus.SpinAndHold, bonus);
		bonusConfig = null;
		bonus = null;
		bonusParams = null;
	}

	protected async SpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonus = this.bonusList.get(Bonus.SpinAndHold);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);
		
		let bonusView = bonus.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";
			
		this.view.appendChild(bonusView);

		// hide all bonuses by default
		bonus.Hide();
		bonus = null;
		bonusView = null;
	}

	protected async ExtendedSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonusConfig: ExtendedSpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.ExtendedSpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.extendedSpinAndHoldFactory.CreateExtendedSpinAndHold2(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.ExtendedSpinAndHold, bonus);
		bonusConfig = null;
		bonus = null;
		bonusParams = null;
		bonusConfig = null
	}

	protected async ExtendedSpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonus = this.bonusList.get(Bonus.ExtendedSpinAndHold);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);
		
		let bonusView = bonus.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";
			
		this.view.appendChild(bonusView);

		// hide all bonuses by default
		bonus.Hide();
		bonus = null
		bonusView = null;
	}

	protected async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;
		let bonusParams: SpinAndHold2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.bigSymbolSpinAndHoldFactory.CreateBigSymbolSpinAndHold2(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "SpinAndHold bonus created");

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, bonus);
		bonusConfig = null;
		bonusParams = null;
		bonus = null;
	}

	protected async BigSymbolSpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;
		let bonus = this.bonusList.get(Bonus.BigSymbolSpinAndHold);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);
		
		let bonusView = bonus.View();
		bonusView.style.width = this.multigameParams.viewSize.Width + "px";
		bonusView.style.height = this.multigameParams.viewSize.Height + "px";
			
		this.view.appendChild(bonusView);

		// hide all bonuses by default
		bonus.Hide();
		bonus = null;
		bonusView = null;
	}


	protected async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager)
	{
		if (loadingStage != LoadingStage.Games) return;

		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonusParams: BigSymbolFreegames2Params = 
		{
			systemContext: this.systemContext,
			gameName: this.name,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol, 
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/BigSymbolFreegames/", 
			commonBonusResourcesBasePath: this.commonpath + "resources/BigSymbolFreegames/",
			viewSize: this.viewSize,
			moneyFormatter: this.moneyFormatter,
			translator: this.translator,
			audio: this.multigameParams.audio
		};


		//FREE GAME FOR 3 Screen
		
		let bonus: SlotBonus2 = this.bigSymbolFreegamesFactory.CreateBigSymbolFreegames2(this.resid, bonusParams, bonusConfig);
		await bonus.PrepareResources(loadingStage, resourceManager);
		// Log.Debug(this.logGroup, "BigSymbolFreegames bonus created");

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
		bonusConfig = null;
		bonus = null;
		bonusParams = null;

	}

	protected async BigSymbolFreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games) return;
		let bonus = this.bonusList.get(Bonus.BigSymbolFreegames);
		await bonus.ResourcesLoaded(loadingStage, resourceManager);
		
		let view = bonus.View();
		view.style.width = this.multigameParams.viewSize.Width + "px";
		view.style.height = this.multigameParams.viewSize.Height + "px";
			
		this.view.appendChild(view);

		// hide all bonuses by default
		bonus.Hide();
		bonus = null;
		view = null;
	}

	public View(): HTMLElement 
	{
		return this.view;
	}
	
	public Update(): void 
	{
		if (this.currentBonus && this.stateMachine.State() == SlotGameState.Bonus) {
			this.currentBonus.Update();
		}
		

		

	if (this.stateMachine.State() == SlotGameState.Win) {
			for (let i = 0; i < this.symbolSpriteAnims.length; i++)
			{
				this.symbolSpriteAnims[i].Update();
			}
		}
		//USE ONLY FOR 3 Screen
		if(this.titleSlideView !=null)
		{
			this.titleSlideView?.Update();
		}
		else
		{
			//DONT USE FOR 2 SCREEN
		}
		
		// TODO move to paytable update to single update
		this.secondScreenHelp?.PayTableUpdate();
		this.secondScreenHelp?.Update();
		
		this.paytable?.Update(true);

		
		
	}

	public StartAnim(): void
	{
		//this.zoomTitleTimer.Start();
	}

	public StopAnim(): void
	{
		//use when TitleGameSlide Settings are enablae 
		this.titleSlideView?.Start();
	}

	// public ZommTitle(): void
	// {
	// 	var tl = new TimelineMax();
	// 	tl.fromTo(this.titleanim, 2.5, {zoom:1},{y:80,zoom:1.2,ease:Elastic.easeOut});

	// 	var tl2 = new TimelineMax();

	// 	tl2.fromTo(this.titleanim, 2.5, {zoom:1.2,y:80},{y:0,zoom:1,ease:Elastic.easeOut});
	// 	tl2.delay(2);
	// }

	public GameSelected(): void {
		// Log.Debug(this.logGroup, "Game selected");

		this.secondScreenHelp?.Start();
		// Log.Debug(this.logGroup, "Title sprite restart");

		this.AnimationStartRequest();
		this.StartAnim();

		this.paytable?.StartAnim();

		this.titleSlideView?.Start();

	}

	public GameExit(): void {
		// Log.Debug(this.logGroup, "Game exited");
		this.secondScreenHelp?.Stop();
		this.secondScreenHelp?.Reset();
		
		this.StopAnim();

		this.AnimationStopRequest();
		this.paytable?.StopAnim();

		
		this.titleSlideView?.Stop();
	}

	/*************************************************************************
		SCREEN MESSAGES
	**************************************************************************/
	protected BonusStart(): void {
		if (this.stateMachine.State() == SlotGameState.Bonus) {

		}
	}

	protected OnBonusRunResult(run: ISimpleBonusAction[]):void
	{
		let indexStartConfig = run.findIndex(b => b.Phase == "Start");
		if(run[indexStartConfig].Bonus ){
			//this.currentBonus.Hide();
			//this.bonusStartConfig = run.BonusStartConfig;
			
			let b =this.bonusList.get(run[indexStartConfig].Bonus as Bonus);
			this.runingBonuses.push(b);
			this.currentBonus?.Hide();
			this.currentBonus = this.bonusList.get(run[indexStartConfig].Bonus as Bonus);
			//this.currentBonus.Show();
		}
	}

	protected OnBonusFinished(message: SlotGameMessages.BonusFinished)
	{
		this.currentBonus?.Stop();
		this.currentBonus?.Hide();
		if(this.runingBonuses.length !=0)
		{
			
			this.runingBonuses.pop();
			if(this.runingBonuses.length !=0)
			{
				this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
				this.currentBonus.Show();
			}
		}		
	}

	protected runingBonuses: SlotBonus2[] = [];
	protected OnSpinResult(spinResult: SimpleSlotGameState): void {
		this.lastSpinResult = spinResult;
		//TODO
		//START
		if(this.lastSpinResult.Actions.length > 1){
			let BonusName = this.lastSpinResult.Actions.find(bonus => bonus.Phase == "Start").Bonus as Bonus
			this.currentBonus = this.bonusList.get(BonusName);
			this.runingBonuses.push(this.currentBonus);
		}
		//END
		
	}

	/*************************************************************************
		INTERNAL STATES
	**************************************************************************/
	protected OnWaitGameStartBegin(): void
	{
		this.secondScreenHelp?.RequestPause();
	}

	protected OnSpinBegin(): void
	{
		this.currentBonus = null;
	}

	protected OnBonusBegin(): void
	{
		//if (this.lastSpinResult && this.lastSpinResult.Bonus) 
		//if(this.runingBonuses.length != 0)
		if(this.currentBonus != null)
		{
			this.currentBonus?.Prepare(this.bonusStartConfig);
			//move because takes much time for create bonus , destroy filling pot , create transition 
			this.currentBonus?.Start();
			this.StopAnim();						
			this.bonusDelayedBeginTimer.Start();
		}
	}

	protected OnBonusDelayedBegin(): void 
	{
		this.secondScreenHelp?.Stop();
		this.secondScreenHelp?.Reset();
		//this.currentBonus?.Start();
		this.currentBonus?.Show();
		//this.currentBonus?.Start();
	}

	protected OnBonusEnd(): void
	{
		this.secondScreenHelp?.Start();
	}

	protected OnWinBegin(): void {
		if (this.lastSpinResult.TotalWin.TotalWin.InCents > 0) {
			/* for (let i = 0; i < this.symbolSpriteAnims.length; i++)
				this.symbolSpriteAnims[i].Start(); */
		}
	}

	protected OnWinEnd(): void {
		for (let i = 0; i < this.symbolSpriteAnims.length; i++)
		{
			this.symbolSpriteAnims[i].Stop();
		}
		
		this.s = -1;
		
		//UPDATE PAYTABLE IN SECONSCRENHELP CLASS
		this.secondScreenHelp?.PayTableUpdate(this.forceUpdatePaytable);
		this.forceUpdatePaytable = false;
	}

	public HasPresentation(): boolean
	{
		return true;
	}

	public AnimationStartRequest(): void
	{
		//USE FOR 3 SCREEN
		// if(this.titleSprite != null)
		// {
		// 	this.titleSprite.Restart(false);
		// 	this.titleSpriteDelayTimer.Restart();
		// }
		// else
		// {
		// 	//USE FOR 2 SCREEN
		// }
	}

	public AnimationStopRequest(): void
	{
		this.secondScreenHelp?.Stop();

		//USE FOR 3 SCREEN
		// if(this.titleSprite !=null)
		// {
		// 	this.titleSprite.Stop();
		// 	this.titleSpriteDelayTimer.Stop();
		// }
		// else
		// {
		// 	//DONT USE FOR 2Screen
		// }
		
	}

	protected forceUpdatePaytable: boolean = false;

	protected s:number = -1
	protected WiningSymbol(symbol: number):void 
	{
		if(symbol != this.s)
		{
			if(this.s != -1)
			{
				this.symbolSpriteAnims[this.s]?.Reset();
				//// Log.Debug(this.logGroup, "symbol " + this.symbolSpriteAnims[this.s].Sprite().Name() + "last frame index " + this.symbolSpriteAnims[this.s].Sprite().CurrentFrameIndex());
				this.symbolSpriteAnims[this.s]?.Stop();
				this.forceUpdatePaytable = true;
			}
			this.symbolSpriteAnims[symbol]?.Start();
			
			
		}
		this.s = symbol;
	}
}
